import { Check2 } from '@styled-icons/bootstrap';

import createStyledIcon from './createStyledIcon';

export default createStyledIcon(Check2);
